import React from "react";
import {
  HeaderSection,
  Items,
  PriceSection,
  Professional,
  ProfessionalButton,
} from "./index.styles";

import Utils from '../../../lib/utils';

import { Isubscription } from "./interface";

interface Iprops {
  subscription?: Isubscription;
  onClick: (subscription?: Isubscription) => {};
}

const ProfessionalComponent = (props: Iprops) => {
  const { subscription, onClick } = props;
  return (
    <Professional>
      <HeaderSection>
        <h3> Professional </h3>
        <p> Best for business making a few hires</p>
      </HeaderSection>
      <PriceSection>
        <p>
          {subscription && Utils.currencyFormatter(subscription.monthly_price.slice(0,3))}/
          <span> Month per recruiter</span>
        </p>
        <p>
          {(subscription && subscription.contact_credits) || 0}{" "}
          <span>Contacts awarded every month</span>
        </p>
      </PriceSection>
      <div>
        <h4> What's included? </h4>
        <Items>
          <li>Unlimited resume searches</li>
          <li>Contact credit when a candidate</li>
          <li>Email reminder sent to unresponsive candidates</li>
          <li>Send messages to multiple candidates at once</li>
          <li>Access to QuirkyCoders insights</li>
        </Items>
      </div>
      <ProfessionalButton
        disabled={!subscription}
        onClick={() => onClick(subscription)}
      >
        Purchase Now
      </ProfessionalButton>
    </Professional>
  );
};
export default ProfessionalComponent;
